import { defineMessages } from 'react-intl-next';

export default defineMessages({
    disclaimerText: {
        defaultMessage:
            'The quality, accuracy, and reliability of information generated by Atlassian Intelligence may vary.',
        description: 'Disclaimer text for Unified Help',
        id: 'unified-help.disclaimer.text.non-final',
    },
    learnWhyLink: {
        defaultMessage: 'Learn why',
        description: 'Learn why link for Unified Help disclaimer',
        id: 'unified-help.disclaimer.learn-why.non-final',
    },
    footerDisclaimerTooltipText: {
        defaultMessage:
            'Your conversations won’t be visible to anyone. Keywords from your conversations may be anonymized and presented to admins to help them improve performance.',
        description: 'Footer disclaimer tooltip text for AI answers in helpcenter',
        id: 'ai-answers.footer.disclaimer.tooltip.text.non-final',
    },
    footerContentQualityDisclaimerText: {
        defaultMessage: 'Content quality may vary.',
        description: 'Footer content quality disclaimer text for AI answers in helpcenter',
        id: 'ai-answers.footer.disclaimer.text.non-final',
    },
    footerConversationStoredDisclaimerText: {
        defaultMessage: 'Conversations are stored for 30 days for analytics purposes.',
        description: 'Footer conversations stored disclaimer text for AI answers in helpcenter',
        id: 'ai-answers.footer.disclaimer.text.non-final',
    },
    poweredByAtlassianIntelligence: {
        defaultMessage: 'Powered by Atlassian Intelligence',
        description: 'Powered by Atlassian Intelligence text for AI answers in helpcenter',
        id: 'ai-answers.powered.by.atlassian.intelligence.non-final',
    },
});
